module.exports = __webpack_public_path__ + "static/img/m_logo.05b915e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/m_logo.png
// module id = ZDuf
// module chunks = 1